import { AdminService, PaginatedBillingAccountResponseDto } from 'app/API';
import type { TCall } from 'app/queries/types/TCall';

type TExportFilters = {
  search: string;
  orderBy: string;
  orderType: 'asc' | 'desc';
};

export const fetchAllBillingAccountsForExport = async (
  call: TCall,
  { search, orderBy, orderType }: TExportFilters,
): Promise<PaginatedBillingAccountResponseDto> => {
  const baseExportParams = {
    pageNo: '1',
    orderBy,
    orderType,
    search,
  };
  const countResponse = await call(() =>
    AdminService.getBillingAccountsList({
      ...baseExportParams,
      pageSize: '1',
    }),
  );

  if (countResponse.count === 0) {
    return { count: 0, data: [] };
  }

  return call(() =>
    AdminService.getBillingAccountsList({
      ...baseExportParams,
      pageSize: countResponse.count.toString(),
    }),
  );
};
